import React, {useState, useEffect, useCallback} from "react";

import axios from "axios";

export const ShipmentContext = React.createContext({
  loading: true
});

export const ShipmentProvider = ({children, carrier, proNumber, googleApiKey, trackingUrl, orderId, loadId, billingZip}) => {

  console.log(carrier, proNumber, trackingUrl, orderId, loadId, billingZip);

  var [shipment, setShipment] = useState()
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState(true);

  useEffect(()=>{
    getShipment();
  }, []);

  const getShipment = useCallback(async () => {
    setLoading(true);

    if(!orderId && (!proNumber || !carrier) && !loadId){
      setLoading(false);
      setError(true);
      return
    }

    const params = new URLSearchParams();
    if(orderId){params.set("order", orderId)};
    if(proNumber){params.set("pro", proNumber)};
    if(carrier){params.set("carrier", carrier)};
    if(loadId){params.set("load_id", loadId)};
    if(billingZip){params.set("billing_zip", billingZip)};

    const url = `${trackingUrl}?${params.toString()}`;

    try{ 
      const response = await axios.get(url);
      if(response.status !== 200){
        setLoading(false);
        setError(true);
        return
      }
      setError(false);
      setShipment(response.data);
      setLoading(false);

      console.log("Shipment Tracked Successfully", response.data);

      if(window?.heap){
        window.heap.track("Shipment Tracked Successfully", response.data.summary);
      }

    }catch(e){
      console.log(e);
      setLoading(false);
      setError(true);

      if(window?.heap){
        window.heap.track("Shipment Tracked Error", {
          proNumber,
          carrier
        });
      }
    }

  }, []);

  return <ShipmentContext.Provider value={{ loading, error, shipment, getShipment, googleApiKey }}>
    {children}
    </ShipmentContext.Provider>;
}
